module.exports = __webpack_public_path__ + "static/media/daedong-story-01.f3a2a8c5.jpg";